export default __webpack_public_path__ + "static/media/productsBcg.7b939037.jpeg";